import React from 'react';
const Form = () => {
    return ( <div>
        <h1>detalle tramo</h1>
    </div> );
}
 
export default Form;